import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { Divider, mediaBreakpointMixin, Box, Text, List, Anchor, TextButton, ButtonGroup, IconButton, IconFacebook, IconInstagram, IconLinkedIn, IconX } from '@zillow/constellation';
import React, { useEffect } from 'react';
import styled from 'styled-components';

var StyledDivider = /*#__PURE__*/styled(Divider).withConfig({
  componentId: "sc-1p4f7au-0"
})(["@media ", "{display:none;}"], mediaBreakpointMixin('md_lte'));
var B2BFooter = function B2BFooter(_ref) {
  var logo = _ref.logo,
    _ref$columns = _ref.columns,
    columns = _ref$columns === void 0 ? [] : _ref$columns,
    disabled = _ref.disabled;
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    setHasLoaded = _React$useState2[1];
  var appendSdkScript = function appendSdkScript() {
    var script = document.createElement('script');
    script.id = 'OneTrust-sdk';
    script.src = 'https://s.zillowstatic.com/s3/pfs/oneTrust-4b23ccee433481744c95.js';
    script.async = true;
    script.defer = true;
    script.crossOrigin = 'anonymous';
    script.onload = function () {
      return setHasLoaded(true);
    };
    document.body.append(script);
  };
  var scriptAlreadyExists = function scriptAlreadyExists() {
    return document.querySelector('script#OneTrust-sdk') !== null;
  };

  /**
   * Runs first time when component is mounted
   * and adds the script to the document.
   */
  useEffect(function () {
    if (!scriptAlreadyExists()) {
      appendSdkScript();
    }
  }, []);
  return /*#__PURE__*/React.createElement(Box, null, disabled ? null : /*#__PURE__*/React.createElement(Box, {
    sx: {
      display: 'grid',
      gridTemplateColumns: 'repeat(12, 1fr)',
      gap: '$spacing.md',
      maxWidth: '$breakpoints.xxl',
      margin: '0 auto',
      padding: '$spacing.xxl $spacing.md',
      borderTop: '1px solid $colors.borderLight',
      '@media $md_lte': {
        gap: '0'
      }
    }
  }, /*#__PURE__*/React.createElement(Box, {
    sx: {
      gridColumn: 'span 3',
      '@media $md_lte': {
        gridColumn: 'span 12',
        marginBottom: '$spacing.md'
      }
    }
  }, logo && /*#__PURE__*/React.createElement(Box, {
    as: "img",
    src: logo.src,
    alt: logo.alt,
    width: logo.width,
    sx: {
      maxWidth: '100%'
    }
  })), /*#__PURE__*/React.createElement(Box, {
    sx: {
      gridColumn: 'span 9',
      display: 'grid',
      gridTemplateColumns: 'repeat(12, 1fr)',
      justifyItems: 'end',
      flexWrap: 'wrap',
      gap: '$spacing.md',
      '@media $md_lte': {
        gridColumn: 'span 12',
        gap: '0',
        justifyItems: 'start'
      }
    }
  }, columns.map(function (column, index) {
    return /*#__PURE__*/React.createElement(Box, {
      key: column.title + '_' + index,
      sx: {
        gridColumn: "span " + 12 / columns.length,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        '@media $md_lte': {
          gridColumn: 'span 6',
          alignItems: 'flex-start',
          marginBottom: '$spacing.md'
        },
        '@media $sm_lte': {
          gridColumn: 'span 12',
          alignItems: 'flex-start'
        }
      }
    }, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Text, {
      as: "h6",
      fontType: 'h6'
    }, column.title), /*#__PURE__*/React.createElement(Text, {
      as: "p",
      fontType: 'bodySmall',
      fontColor: "textLight"
    }, column.description), /*#__PURE__*/React.createElement(List, {
      appearance: "none",
      paddingtop: 'sm'
    }, column.links.map(function (link, index) {
      return /*#__PURE__*/React.createElement(List.Item, {
        key: link.title + '_' + index
      }, /*#__PURE__*/React.createElement(Box, {
        as: Anchor,
        href: link.url,
        sx: {
          '&&': {
            color: '$colors.blue400',
            ':hover': {
              color: '$colors.blue500'
            }
          }
        }
      }, link.title));
    }))));
  }))), /*#__PURE__*/React.createElement(Box, {
    sx: {
      backgroundColor: '$colors.backgroundDarkBlue'
    }
  }, /*#__PURE__*/React.createElement(Box, {
    sx: {
      padding: '$spacing.md',
      maxWidth: '$breakpoints.xxl',
      margin: '0 auto',
      minHeight: '106px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      flexWrap: 'wrap'
    }
  }, /*#__PURE__*/React.createElement(Box, {
    sx: {
      display: 'flex',
      alignItems: 'stretch',
      flexWrap: 'wrap',
      '@media $md_lte': {
        marginBottom: '$spacing.md',
        maxWidth: '$breakpoints.sm'
      }
    }
  }, /*#__PURE__*/React.createElement(Text, {
    fontColor: "textWhite"
  }, "\xA9 ", /*#__PURE__*/React.createElement("span", null, new Date().getFullYear()), ' ', "Zillow Group, Inc. and its subsidiaries. All rights reserved."), /*#__PURE__*/React.createElement(StyledDivider, {
    orientation: "vertical",
    marginX: "sm"
  }), /*#__PURE__*/React.createElement(TextButton, {
    as: "a",
    href: "#",
    fontType: "body",
    className: "cookie-preference",
    inverse: true
  }, "Cookie Preferences")), disabled ? null : /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(ButtonGroup, {
    "aria-label": "Button type example"
  }, /*#__PURE__*/React.createElement(IconButton, {
    as: 'a',
    icon: /*#__PURE__*/React.createElement(IconFacebook, null),
    title: "Facebook",
    size: "sm",
    href: "https://www.facebook.com/Zillow/"
  }), /*#__PURE__*/React.createElement(IconButton, {
    as: 'a',
    size: "sm",
    title: "Instagram",
    icon: /*#__PURE__*/React.createElement(IconInstagram, null),
    href: "https://www.instagram.com/zillow/"
  }), /*#__PURE__*/React.createElement(IconButton, {
    as: 'a',
    size: "sm",
    title: "LinkedIn",
    icon: /*#__PURE__*/React.createElement(IconLinkedIn, null),
    href: "https://www.linkedin.com/company/zillow/"
  }), /*#__PURE__*/React.createElement(IconButton, {
    as: 'a',
    icon: /*#__PURE__*/React.createElement(IconX, null),
    title: "X",
    size: "sm",
    href: "https://x.com/zillow/"
  }))))));
};
var B2BFooter$1 = B2BFooter;

export { B2BFooter$1 as default };
